import { EndpointModulesView } from '../view/EndpointModulesView';
import { templateEndpointModules } from '../view/template';
import { EndpointModulesWebComponent } from '../component/EndpointModulesWebComponent';
import { BaseWidgetController } from '../../widget/BaseWidgetController';
import { GetEndpointModuleStatusResponse } from '@nirvana/shared/dtos/types/widgets/common';

export class EndpointModulesController extends BaseWidgetController<GetEndpointModuleStatusResponse> {
  public component: EndpointModulesWebComponent;
  public view: EndpointModulesView;
  public viewConstructor: typeof EndpointModulesView;

  constructor(component: EndpointModulesWebComponent) {
    super(component);
    this.initialWidgetSetup({
      viewConstructor: EndpointModulesView,
      viewTemplate: templateEndpointModules,
      dataFetchMethod: this.component.dependencies.api.clients.Widgets.getEndpointModuleStatus,
    });
  }
}
